// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 自定义 Tailwind 类 */
.w-25[data-v-4e1b765c] {
  width: 100px;
}
.left-25[data-v-4e1b765c] {
  left: 100px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
